<template>
    <div class="container">
        <div class="footer-booking fade-in" v-bind:class="cartDisplayed">
            <div class="container-left nopadd-mob">
                <div class="footer-booking-fields">
                    <div class="dates-wrapper">
                        <div ref="datepickertrigger" class="datepicker-trigger"></div>
                        <input ref="apartmentdatepicker" type="hidden" />
                        <input type="hidden" name="arrive" value="" />
                        <input type="hidden" name="depart" value="" />
                        <div class="dates-display button small tertiary icon-left">
                            <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><title>calendar</title><path d="M38.5,40H9.5a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h4.76V6.81h2V9h16V6.81h2V9H38.5a2,2,0,0,1,2,2V38A2,2,0,0,1,38.5,40ZM9.5,17.81V38h29V17.81Zm0-2h29V11H34.26v2h-2V11h-16v2h-2V11H9.5Zm9.38,6.92a1,1,0,0,0,.33-.21,1.19,1.19,0,0,0,.22-.33,1.07,1.07,0,0,0,0-.76,1.46,1.46,0,0,0-.22-.33,1,1,0,0,0-1.09-.21.9.9,0,0,0-.54.54.94.94,0,0,0,0,.76.9.9,0,0,0,.54.54.94.94,0,0,0,.76,0Zm5.34,0a1,1,0,0,0,.32-.21,1,1,0,0,0,.22-.33,1.07,1.07,0,0,0,0-.76,1.19,1.19,0,0,0-.22-.33,1,1,0,0,0-1.09-.21,1,1,0,0,0-.32.21,1.06,1.06,0,0,0-.22.33,1.07,1.07,0,0,0,0,.76,1,1,0,0,0,.22.33,1,1,0,0,0,1.09.21Zm5.33,0a.9.9,0,0,0,.54-.54.94.94,0,0,0,0-.76,1,1,0,0,0-.21-.33,1,1,0,0,0-.91-.27l-.18.06a.76.76,0,0,0-.18.09,1.58,1.58,0,0,0-.15.12,1.46,1.46,0,0,0-.22.33,1.07,1.07,0,0,0,0,.76,1.19,1.19,0,0,0,.22.33,1,1,0,0,0,.33.21.94.94,0,0,0,.76,0Zm5.33,0a1.15,1.15,0,0,0,.33-.21,1.19,1.19,0,0,0,.22-.33,1,1,0,0,0,.07-.38.84.84,0,0,0-.08-.38,1,1,0,0,0-.21-.33.93.93,0,0,0-.33-.21,1,1,0,0,0-1.09.21,1.15,1.15,0,0,0-.21.33.94.94,0,0,0,0,.76.9.9,0,0,0,.54.54.94.94,0,0,0,.76,0ZM19.21,26.52a1,1,0,0,0,.29-.71.62.62,0,0,0,0-.19,1.05,1.05,0,0,0-.05-.19,1.62,1.62,0,0,0-.1-.18,1.58,1.58,0,0,0-.12-.15.93.93,0,0,0-.33-.21,1,1,0,0,0-.76,0,1.15,1.15,0,0,0-.33.21,1.05,1.05,0,0,0-.29.71,1,1,0,0,0,.29.71,1.15,1.15,0,0,0,.33.21,1,1,0,0,0,1.09-.21Zm5.33,0a1,1,0,0,0,.3-.71,1,1,0,0,0-1.39-.92,1,1,0,0,0-.32.21,1,1,0,0,0-.29.71,1,1,0,0,0,.61.92,1,1,0,0,0,.39.08A1,1,0,0,0,24.54,26.52Zm5.34,0a1,1,0,0,0,.29-.71,1,1,0,1,0-2,0,1,1,0,0,0,.29.71,1,1,0,0,0,.33.21,1,1,0,0,0,1.09-.21Zm5.33,0a1,1,0,0,0,.29-.71.62.62,0,0,0,0-.19,1.05,1.05,0,0,0,0-.19,1.62,1.62,0,0,0-.1-.18,1.58,1.58,0,0,0-.12-.15.93.93,0,0,0-.33-.21,1,1,0,0,0-.76,0,1.15,1.15,0,0,0-.33.21,1.05,1.05,0,0,0-.29.71,1,1,0,0,0,.29.71,1,1,0,0,0,1.42,0Zm-16,4a1,1,0,0,0,.29-.71,1.05,1.05,0,0,0-.29-.71,1,1,0,0,0-1.09-.21,1.15,1.15,0,0,0-.33.21,1.05,1.05,0,0,0-.29.71,1,1,0,0,0,.29.71,1.15,1.15,0,0,0,.33.21,1,1,0,0,0,1.09-.21Zm5,.21a1,1,0,0,0,.54-1.3.91.91,0,0,0-.22-.33,1,1,0,0,0-1.09-.21,1,1,0,0,0-.32.21.91.91,0,0,0-.22.33,1,1,0,0,0,1.31,1.3Zm5.33,0a1.15,1.15,0,0,0,.33-.21,1,1,0,0,0,.29-.71,1.05,1.05,0,0,0-.29-.71,1.15,1.15,0,0,0-.33-.21,1,1,0,0,0-1.09.21,1,1,0,0,0-.21.33.84.84,0,0,0-.08.38,1,1,0,0,0,1.38.92Zm5.66-.21a1,1,0,0,0,.29-.71,1,1,0,0,0-1.19-1,.6.6,0,0,0-.19.06A.56.56,0,0,0,34,29a.61.61,0,0,0-.15.12,1,1,0,0,0-.3.71,1,1,0,0,0,.3.71,1,1,0,0,0,.7.29A1,1,0,0,0,35.21,30.52Zm-16,4a1,1,0,0,0,.29-.71,1.05,1.05,0,0,0-.29-.71,1,1,0,0,0-1.09-.21,1.15,1.15,0,0,0-.33.21,1,1,0,0,0-.21.33,1,1,0,0,0-.08.38,1,1,0,0,0,.29.71,1,1,0,0,0,1.42,0Zm-5-8a1,1,0,0,0,.29-.71,1.05,1.05,0,0,0-.29-.71,1,1,0,0,0-1.09-.21,1.15,1.15,0,0,0-.33.21,1.05,1.05,0,0,0-.29.71,1,1,0,0,0,.29.71,1.15,1.15,0,0,0,.33.21,1,1,0,0,0,1.09-.21Zm0,4a1,1,0,0,0,.29-.71,1,1,0,0,0-1.19-1,.6.6,0,0,0-.19.06A.56.56,0,0,0,13,29a1,1,0,0,0-.16.12,1.05,1.05,0,0,0-.29.71,1,1,0,0,0,.29.71,1,1,0,0,0,1.42,0Zm0,4a1,1,0,0,0,.29-.71.84.84,0,0,0-.08-.38,1,1,0,0,0-.21-.33,1.05,1.05,0,0,0-.9-.27.6.6,0,0,0-.19.06A.56.56,0,0,0,13,33a.61.61,0,0,0-.15.12,1,1,0,0,0-.3.71,1,1,0,0,0,.3.71,1,1,0,0,0,.7.29A1,1,0,0,0,14.21,34.52Zm10.33,0a1,1,0,0,0,.22-1.09,1.06,1.06,0,0,0-.22-.33,1,1,0,0,0-.9-.27.7.7,0,0,0-.19.06.56.56,0,0,0-.17.09l-.15.12a1,1,0,0,0-.3.71,1,1,0,0,0,1,1A1,1,0,0,0,24.54,34.52Zm5.34,0a1,1,0,0,0,.29-.71,1.05,1.05,0,0,0-.29-.71,1.15,1.15,0,0,0-.33-.21,1,1,0,0,0-.76,0,.93.93,0,0,0-.33.21,1.27,1.27,0,0,0-.22.33,1,1,0,0,0,1.64,1.09Z"/></svg>
                            <span class="check-in-display">{{ displayedStartDate }}</span>
                            <span class="divider"><svg width="6" height="16" viewBox="0 0 14 23" xmlns="http://www.w3.org/2000/svg"><path d="M13.507 11.542L2.543.578.422 2.7l8.843 8.842-8.843 8.843 2.12 2.122z" fill="#000" fill-rule="evenodd"/></svg></span>
                            <span class="check-out-display">{{ displayedEndDate }}</span>
                        </div>
                    </div>
                    <div class="filter-group rooms-guests">
                        <div class="rooms-guests-display small button tertiary icon-left" v-bind:class="roomsAndGuestsSelectorActive" @click="toggleRoomsAndGuestsSelector">
                            <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><title>user</title><path fill="#fff" d="M28.838,23.607a10.167,10.167,0,1,0-9.676,0A15.687,15.687,0,0,0,8.333,38.5h2a13.667,13.667,0,0,1,27.334,0h2A15.687,15.687,0,0,0,28.838,23.607Zm-13-8.94A8.167,8.167,0,1,1,24,22.833,8.177,8.177,0,0,1,15.833,14.667Z"/></svg>
                            <span class="guests-display">{{ filtersToApply.numberOfAdults + filtersToApply.numberOfChildren }} {{ translations.guests }}</span>
                        </div>
                        <div class="rooms-guests-select" v-bind:class="roomsAndGuestsSelectorActive">
                            <div class="rooms-guests-select-inner">
                                <div class="selector-wrap">
                                    <input type="hidden" class="count-guests" name="guests" :value="filtersToApply.numberOfAdults" />
                                    <p>{{ translations.adults }}</p>
                                    <div class="selector">
                                        <button class="secondary" v-bind:class="numberOfAdultsDecrementable" @click="decrementAdults">–</button>
                                        <span class="selector-value">{{ filtersToApply.numberOfAdults }}</span>
                                        <button class="secondary" v-bind:class="numberOfAdultsIncrementable" @click="incrementAdults">+</button>
                                    </div>
                                </div>
                                <div class="selector-wrap">
                                    <input type="hidden" class="count-guests" name="children" :value="filtersToApply.numberOfChildren" />
                                    <p>
                                        {{ translations.children }}<br>
                                        <span>{{ translations.children_guidelines }}</span>
                                    </p>
                                    <div class="selector">
                                        <button class="secondary" v-bind:class="numberOfChildrenDecrementable" @click="decrementChildren">–</button>
                                        <span class="selector-value">{{ filtersToApply.numberOfChildren }}</span>
                                        <button class="secondary" v-bind:class="numberOfChildrenIncrementable" @click="incrementChildren">+</button>
                                    </div>
                                </div>
                                <a href="#" class="rooms-guests-close" @click="toggleRoomsAndGuestsSelector()">{{ translations.close }}</a>
                            </div>
                        </div>
                    </div>
                    <div class="filter-group option-select">
                        <div class="option-display small button invert icon-left" v-bind:class="featuresSelectorActive" @click="toggleFeaturesSelector">
                            <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><title>star</title><path fill="#262F54" d="M36.046,42.971a1.779,1.779,0,0,1-.835-.225L24.413,37a1.143,1.143,0,0,0-.826,0l-10.8,5.75a1.424,1.424,0,0,1-2.163-1.571l2.133-12.048a1.151,1.151,0,0,0-.256-.785L3.7,19.85a1.425,1.425,0,0,1,.826-2.543L16.64,15.612a1.144,1.144,0,0,0,.667-.484l5.356-11a1.424,1.424,0,0,1,2.674,0l5.356,11a1.141,1.141,0,0,0,.667.485l12.117,1.695A1.425,1.425,0,0,1,44.3,19.85L35.5,28.343a1.147,1.147,0,0,0-.256.785l2.133,12.046a1.5,1.5,0,0,1-.533,1.541A1.337,1.337,0,0,1,36.046,42.971ZM24,34.917a2.918,2.918,0,0,1,1.353.313l9.868,5.255L33.272,29.476a3.084,3.084,0,0,1,.836-2.572l8.047-7.762L31.083,17.593A3.073,3.073,0,0,1,28.9,16L24,5.952,19.105,16a3.074,3.074,0,0,1-2.188,1.59L5.845,19.142,13.892,26.9a3.087,3.087,0,0,1,.836,2.573l-1.95,11.009,9.869-5.255A2.918,2.918,0,0,1,24,34.917Z"/></svg>
                            <span class="option-text">{{ translations.key_features }}</span>
                        </div>
                        <div class="option-selector" v-bind:class="featuresSelectorActive">
                            <div class="option-selector-inner">
                                <a v-for="featureChoice in featureChoices" :key="featureChoice.code" v-bind:class="{ active: isFeatureSelected(featureChoice.code) }" @click.prevent="toggleFeatureSelected(featureChoice.code)">{{ featureChoice.name }}</a>
                            </div>
                        </div>
                    </div>
                    <div class="filter-group option-select" v-if="showGroupSelector">
                        <div class="option-display small button invert icon-left" v-bind:class="groupsSelectorActive" @click="toggleGroupsSelector">
                            <svg width="24" height="24" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke="#262F54" stroke-miterlimit="10" stroke-width="2"><path d="m21.069 16.759 6.741-6.741a1.683 1.683 0 0 1 2.381 0l7.809 7.808a1.683 1.683 0 0 1 0 2.381l-18.968 18.968"/><path d="m31.289 26.918h9.429a1.684 1.684 0 0 1 1.682 1.682v11.044a1.684 1.684 0 0 1 -1.684 1.684h-26.822"/><path d="m8.342 5.542h11.043a1.684 1.684 0 0 1 1.684 1.684v26.823a7.205 7.205 0 0 1 -7.205 7.205 7.205 7.205 0 0 1 -7.205-7.205v-26.824a1.684 1.684 0 0 1 1.683-1.683z"/><circle cx="13.863" cy="34.123" r="1.88"/></g></svg>
                            <span class="option-text">{{ translations.apartment_brand }}</span>
                        </div>
                        <div class="option-selector" v-bind:class="groupsSelectorActive">
                            <div class="option-selector-inner">
                                <a
                                    v-for="(code, value) in groupChoices"
                                    :key="code"
                                    :class="{ active: isGroupSelected(code) }"
                                    href=''
                                    @click.prevent="toggleGroupSelected(code)"
                                >
                                  {{ value }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cart-total-wrapper">
                  <div style="justify-content: flex-end; width: unset !important; padding: 0;" class="cart-total">
                      <button class="button distributor-open" :class="`distributor-open-${currentDateSelectionKey}`">
                        {{ $t('proceed_to_booking') }}
                      </button>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import 'daterangepicker/daterangepicker.js';
import 'daterangepicker/daterangepicker.css';
import filterMixin from '@/mixins/filterMixin'
import mewsDistributorMixin from '@/mixins/mewsDistributorMixin'
import moment from "moment";

export default {
  mixins: [
    filterMixin,
    mewsDistributorMixin,
  ],
  props: {
    initialFeatures: String,
    initialGroup: String,
    initialNumberOfAdults: Number,
    initialNumberOfChildren: Number,
    initialNumberOfRooms: Number,
    maximumNumberOfAdults: Number,
    maximumNumberOfChildren: Number,
    maximumNumberOfGuests: Number,
    maximumNumberOfRooms: Number,
    minimumNumberOfAdults: Number,
    minimumNumberOfChildren: Number,
    minimumNumberOfRooms: Number,
    showCart: Boolean,
    showGroupSelector: Boolean,
  },
  data() {
    /* global wpData:true */
    /* eslint no-undef: "error" */
    return {
      displayedEndDate: '',
      displayedStartDate: '',
      featureChoices: [],
      featuresSelectorShown: false,
      filtersApplied: {
        endDate: '',
        features: [],
        group: '',
        numberOfAdults: 1,
        numberOfChildren: 0,
        startDate: ''
      },
      filtersToApply: {
        endDate: '',
        features: [],
        group: '',
        numberOfAdults: 1,
        numberOfChildren: 0,
        startDate: ''
      },
      groupChoices: [],
      groupsSelectorShown: false,
      roomsAndGuestsSelectorShown: false,
      translations: {},
      wpData,
    }
  },
  computed: {
    cartDisplayed: function() {
      return {
        "with-cart": this.showCart
      }
    },
    featureSelected: function(featureCode) {
      return {
        active: this.isFeatureSelected(featureCode)
      }
    },
    featuresSelectorActive: function() {
      return {
        active: this.featuresSelectorShown
      }
    },
    groupsSelectorActive: function() {
      return {
        active: this.groupsSelectorShown
      }
    },
    numberOfAdultsDecrementable: function() {
      return {
        disabled: this.filtersToApply.numberOfAdults <= this.minimumNumberOfAdults
      }
    },
    numberOfAdultsIncrementable: function() {
      if (this.filtersToApply.numberOfAdults === this.maximumNumberOfAdults) {
        return {
          disabled: true,
        }
      }

      return {
        disabled: (this.filtersToApply.numberOfAdults + this.filtersToApply.numberOfChildren) >= this.maximumNumberOfGuests
      }
    },
    numberOfChildrenDecrementable: function() {
      return {
        disabled: this.filtersToApply.numberOfChildren <= this.minimumNumberOfChildren
      }
    },
    numberOfChildrenIncrementable: function() {
      if (this.filtersToApply.numberOfChildren === this.maximumNumberOfChildren) {
        return {
          disabled: true,
        }
      }

      return {
        disabled: (this.filtersToApply.numberOfAdults + this.filtersToApply.numberOfChildren) >= this.maximumNumberOfGuests
      }
    },
    roomsAndGuestsSelectorActive: function() {
      return {
        active: this.roomsAndGuestsSelectorShown
      }
    }
  },
  methods: {
    instantiateDatePicker (startDate, endDate) {
      const onDatesSelected = (startDate, endDate) => {
        this.filtersToApply.startDate = startDate;
        this.filtersToApply.endDate = endDate;

        this.displayedStartDate = startDate.format('D MMM');
        this.displayedEndDate = endDate.format('D MMM');

        if (
            this.filtersToApply.startDate !== this.filtersApplied.startDate ||
            this.filtersToApply.endDate !== this.filtersApplied.endDate
        ) {
          this.filtersApplied.startDate = this.filtersToApply.startDate;
          this.filtersApplied.endDate = this.filtersToApply.endDate;
          
          var elementsIn = document.querySelectorAll("input[name=arrive]");
          elementsIn[0].value= this.filtersApplied.startDate.format("YYYY-MM-DD");
          var elementsOut = document.querySelectorAll("input[name=depart]");
          elementsOut[0].value= this.filtersApplied.endDate.format("YYYY-MM-DD");

          this.updateURL({
            arrivalDate: this.filtersApplied.startDate.format("YYYY-MM-DD"),
            departureDate: this.filtersApplied.endDate.format("YYYY-MM-DD"),
            features: this.filtersApplied.features.join(),
            group: this.filtersApplied.group,
            minAdults: this.filtersApplied.numberOfAdults,
            minChildren: this.filtersApplied.numberOfChildren
          });

          this.$emit('change', {
            emittedFromDatePicker: true,
            currentDateSelectionKey: this.currentDateSelectionKey,
            endDate: this.filtersApplied.endDate,
            features: this.filtersApplied.features.join(),
            group: this.filtersApplied.group,
            numberOfAdults: this.filtersApplied.numberOfAdults,
            numberOfChildren: this.filtersApplied.numberOfChildren,
            startDate: this.filtersApplied.startDate
          });

          this.instantiateMewsDistributor(startDate.toDate(), endDate.toDate())
        }
      };

      $(this.$refs.datepickertrigger).daterangepicker(
          {
            "startDate": startDate,
            "endDate": endDate,
            "minDate": moment().toDate(),
            "locale": {
              format: 'DD/MM/YYYY',
              firstDay: 1
            },
            "buttonClasses": "button",
            "autoApply": true,
            "drops": "up"
          },
          onDatesSelected
      );

      this.displayedStartDate = startDate.format('D MMM');
      this.displayedEndDate = endDate.format('D MMM');

      $(this.$refs.datepickertrigger).on('show.daterangepicker', function() {
        $(this).parent().find('.dates-display').toggleClass('active');
      });

      $(this.$refs.datepickertrigger).on('hide.daterangepicker', function() {
        $(this).parent().find('.dates-display').toggleClass('active');
      });
    },
    updateURL(queryParameters) {
      let url = new URL(window.location.href);

      for (let parameterName in queryParameters) {
        if(queryParameters[parameterName] !== "" && queryParameters[parameterName] !== undefined) {
          url.searchParams.set(parameterName, queryParameters[parameterName]);
        } else if(url.searchParams.has(parameterName)){
          url.searchParams.delete(parameterName);
        }
      }

      let queryLinks = document.getElementsByClassName('js-query-link');

      for (let i=0; i < queryLinks.length; i++) {
        queryLinks[i].href = queryLinks[i].href.split("?")[0] + url.search;
      }

      history.replaceState(null, null, url.href);
    },
    decrementAdults() {
      this.filtersToApply.numberOfAdults--;
    },
    incrementAdults() {
      this.filtersToApply.numberOfAdults++;
    },
    decrementChildren() {
      this.filtersToApply.numberOfChildren--;
    },
    incrementChildren() {
      this.filtersToApply.numberOfChildren++;
    },
    isFeatureSelected(featureCode) {
      return this.filtersToApply.features.includes(featureCode);
    },
    isGroupSelected(groupCode) {
      return this.filtersToApply.group === groupCode;
    },
    toggleFeatureSelected(featureCode) {
      if (this.isFeatureSelected(featureCode)) {
        this.filtersToApply.features = this.filtersToApply.features.filter(f => f !== featureCode);
      } else {
        this.filtersToApply.features.push(featureCode);
      }
    },
    toggleFeaturesSelector() {
      this.featuresSelectorShown = !this.featuresSelectorShown;

      if (this.featuresSelectorShown === true) {
        return
      }

      const haveFeaturesChanged = this.filtersToApply.features.length !== this.filtersApplied.features.length ||
          this.filtersToApply.features.every(featureCode => this.filtersApplied.features.includes(featureCode)) === false;

      if (haveFeaturesChanged === false) {
        return
      }

      this.filtersApplied.features = this.filtersToApply.features.slice(0);

      this.emitChange()
    },
    toggleGroupSelected(groupCode) {
      if(this.filtersToApply.group === groupCode) {
        this.filtersToApply.group = '';
      } else {
        this.filtersToApply.group = groupCode;
      }

      if(this.filtersToApply.group !== this.filtersApplied.group) {
        this.filtersApplied.group = this.filtersToApply.group;

        this.emitChange()
      }

      this.toggleGroupsSelector();
    },
    toggleGroupsSelector() {
      this.groupsSelectorShown =  !this.groupsSelectorShown;
    },
    toggleRoomsAndGuestsSelector() {
      this.roomsAndGuestsSelectorShown =  !this.roomsAndGuestsSelectorShown;

      if (this.roomsAndGuestsSelectorShown === true) {
        return
      }

      if (
          this.filtersToApply.numberOfAdults !== this.filtersApplied.numberOfAdults ||
          this.filtersToApply.numberOfChildren !== this.filtersApplied.numberOfChildren
      ) {

        this.filtersApplied.numberOfAdults = this.filtersToApply.numberOfAdults;
        this.filtersApplied.numberOfChildren = this.filtersToApply.numberOfChildren;

        this.emitChange()
      }
    },
    emitChange () {
      this.$emit('change', {
        endDate: this.filtersApplied.endDate,
        features: this.filtersApplied.features.join(),
        group: this.filtersApplied.group,
        numberOfAdults: this.filtersApplied.numberOfAdults,
        numberOfChildren: this.filtersApplied.numberOfChildren,
        startDate: this.filtersApplied.startDate
      });
    },
    setLocale() {
      const url = new URL(window.location.href);
      const language = url.searchParams.get('lang');

      this.$i18n.locale = document.getElementsByTagName('html')[0].getAttribute('lang');

      if (this.$i18n.availableLocales.indexOf(language) === -1) {
        this.translations = this.$i18n.messages[this.$i18n.fallbackLocale];
      } else {
        this.translations = this.$i18n.messages[language];
      }
    },
  },
  async mounted() {
    this.setLocale()

    this.filtersToApply.numberOfAdults = Number(this.initialNumberOfAdults);
    this.filtersToApply.numberOfChildren = Number(this.initialNumberOfChildren);
    this.filtersApplied.numberOfAdults = Number(this.initialNumberOfAdults);
    this.filtersApplied.numberOfChildren = Number(this.initialNumberOfChildren);

    this.filtersToApply.features = this.initialFeatures.split(",");
    this.filtersApplied.features = this.initialFeatures.split(",");

    this.filtersToApply.group = this.initialGroup;
    this.filtersApplied.group = this.initialGroup;

    this.featureChoices = this.wpData.features || []
    console.log(this.featureChoices)
    this.groupChoices = this.wpData.groups || []

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    const startDate = new moment(params.arrivalDate || new Date())
    const endDate = new moment(params.departureDate || new Date()).add(1, 'days')

    this.instantiateDatePicker(startDate, endDate)
    this.instantiateMewsDistributor(startDate.toDate(), endDate.toDate())

    if(this.wpData['numa']){
      var bookingURL = this.wpData['numa'];
      document.addEventListener("DOMContentLoaded", function() {
          var elements = document.querySelectorAll(".distributor-open");
          for (var i = 0; i < elements.length; i++) {
              var numaLogo = '<svg style="width:4rem; margin-left: 0.25rem;" viewBox="0 0 3000 594.9" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin"><g fill="currentColor"><path d="M552.6,205.9v373.8H391.3V257.2c0-94.8-58.8-124.2-113.3-124.2c-29.4,0-62.1,7.6-92.6,40.3l-6.5-4.3        C201.7,50.1,278,0,368.4,0S552.6,49,552.6,205.9z"></path><path d="M1040.3,421.6l6.5,4.4C1025,545.9,952,594.9,862.7,594.9c-91.5,0-188.5-49-188.5-205.9V16.3h161.3v322.5        c0,94.8,57.8,124.2,113.3,124.2C977.1,463.1,1009.8,454.4,1040.3,421.6z"></path><path d="M1901.7,205.9v373.8h-161.2V257.2c0-94.8-57.8-124.2-113.3-124.2c-28.3,0-61,7.6-91.5,40.3l-6.5-4.3        C1551.9,50.1,1628.2,0,1718.6,0S1901.7,49,1901.7,205.9z"></path><rect y="16.3" width="161.3" height="563.4"></rect><rect x="1064.5" y="16.3" width="161.3" height="563.4"></rect><rect x="1350.2" y="16.3" width="161.3" height="563.4"></rect><path d="M2290.1,205.9v373.8h-161.3V257.2c0-94.8-58.8-124.2-113.3-124.2c-28.3,0-62.1,7.6-91.5,40.3l-6.5-4.3        C1939.3,50.1,2016.6,0,2106,0C2197.5,0,2290.1,49,2290.1,205.9z"></path><path d="M2559.3,297.7c0,100.2,59.9,172,144.8,172c43.5,0,79.5-18.5,109.9-50.1l6.5,4.3        c-17.4,125.2-99.1,170.9-184,170.9c-142.6,0-242.8-129.5-242.8-297.2S2494,0.5,2636.6,0.5c84.9,0,166.6,45.7,184,170.9l-6.5,4.4        c-30.5-31.6-66.4-49-109.9-49C2619.2,126.8,2559.3,198.6,2559.3,297.7z"></path><rect x="2838.9" y="16.3" width="161.1" height="563.3"></rect></g></svg>';
              var link = document.createElement("a");
              link.className = "button numa-booking";
              link.innerHTML = "Book Now With "+numaLogo;
              link.setAttribute("bookingURL", bookingURL);
              elements[i].parentNode.replaceChild(link, elements[i]);
          }
      });
    }
  },
}
</script>
